import type { AsyncSequence } from "../types/AsyncSequence"

export async function ReduceAsync<T, A>(
  func: (accumulator: A, item: T, index: number) => A | Promise<A>,
  sequence: AsyncSequence<T>,
  initial: A
): Promise<A> {
  let accumulator = initial
  let index = 0

  for await (const item of sequence) {
    accumulator = await func(accumulator, item, index++)
  }

  return accumulator
}
